import { render, staticRenderFns } from "./auth_nlg.vue?vue&type=template&id=509554d4&scoped=true&"
import script from "./auth_nlg.vue?vue&type=script&lang=js&"
export * from "./auth_nlg.vue?vue&type=script&lang=js&"
import style0 from "./auth_nlg.vue?vue&type=style&index=0&id=509554d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509554d4",
  null
  
)

export default component.exports